
    import Vue from "vue";
    import {Component} from "vue-property-decorator";
    import {VueInject} from "../VueIntegration/VueInjectable";
    import {Slideshow} from "../slideshow";
    import VueButton from "../UI/VueButton.vue";
    import Modal from "../UI/Modal.vue";
    import AccessibilityGuide from "../UI/AccessibilityGuide.vue";
    import {announce} from "@/UI/Announce";

    @Component({
        components: {AccessibilityGuide, Modal, VueButton}
    })
    export default class TitleSlide extends Vue {
        @VueInject("Slideshow") slideshow: Slideshow;

        showAccessibilityModal = false;

        start() {
            this.slideshow.nextSlide();
        }

        mounted() {
            this.slideshow.slideEntered();
            announce("To begin the tutorial, please use the start button in the main region of the page.");
        }

        openSettings() {
            this.$emit('settings');
        }

        openAccessibility() {
            this.$emit('accessibility');
        }
    }
